import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var tag = 'fx_2d2fb1e5_1wjql6d5';
var tagBackground = 'var(--fx_2d2fb1e5_1wjql6d1)';
var tagColor = 'var(--fx_2d2fb1e5_1wjql6d0)';
var tagHorizontalGap = 'var(--fx_2d2fb1e5_1wjql6d4)';
var tagVariants = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_1wjql6d6',variantClassNames:{size:{small:'fx_2d2fb1e5_1wjql6d7','default':'fx_2d2fb1e5_1wjql6d8',large:'fx_2d2fb1e5_1wjql6d9'},variant:{weak:'fx_2d2fb1e5_1wjql6da',solid:'fx_2d2fb1e5_1wjql6db',outline:'fx_2d2fb1e5_1wjql6dc'}},defaultVariants:{},compoundVariants:[]});

export { tag, tagBackground, tagColor, tagHorizontalGap, tagVariants };
//# sourceMappingURL=tag.vanilla.mjs.map
